export default class {
    constructor (MomentService) {
        this.MomentService = MomentService;
    }

    convertFormFields (form) {
        // if deadline given as timestamp, convert it to standard format
        if (form.model.deadline && !isNaN(form.model.deadline)) {
            // we keep standard format in utc timezone
            form.model.deadline = this.MomentService.formatTimeStamp(form.model.deadline, 'YYYY-MM-DD HH:mm:ss', true);
        }
    }

    getCKEditorConfig () {
        return {
            toolbar: [
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
                { name: 'links', items: ['Link', 'Unlink'] }
            ],
            removeButtons: 'Cut,Copy,Paste,Undo,Redo,Anchor,About'
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/services/evaluation/index.js